import t from "react";
import { useTranslation as v } from "react-i18next";
import { useAuth as C } from "../../../../auth/hooks/useAuth.js";
import { UserInitials as E } from "../../User/components/UserInitials/UserInitials.js";
import { useWindowSize as d } from "../../../../dom/hooks/useWindowSize.js";
import { useNavigation as N } from "../../Navigation/hooks/useNavigation.js";
import { useNavbar as k } from "../hooks/useNavbar/useNavbar.js";
import b from "../menu.svg.js";
import r from "../navbar.module.scss.js";
function z(x) {
  var l, c;
  const {
    isDesktop: a
  } = d(), {
    design: e,
    menu: o,
    isDropdownMenuOpen: m,
    setIsDropdownMenuOpen: s
  } = k(), {
    navigate: u
  } = N(), {
    customer: n,
    logout: p,
    login: h
  } = C(), {
    t: i
  } = v(), _ = () => {
    s((g) => !g);
  }, f = () => {
    o != null && o.props.showSeeProfileLink && u("/account", {
      overrideHistory: !0
    });
  };
  return /* @__PURE__ */ t.createElement("div", { "data-testid": "right-side-menu", className: r.navbar__rightContainer }, o && !a && /* @__PURE__ */ t.createElement("div", { className: r.navbar__menuContainer }, /* @__PURE__ */ t.createElement(
    "div",
    {
      style: {
        cursor: "pointer",
        color: e == null ? void 0 : e.hightLighHightlight
      },
      "data-testid": "open-icon",
      onClick: () => _()
    },
    m ? /* @__PURE__ */ t.createElement(
      "i",
      {
        style: {
          color: e == null ? void 0 : e.hightLighHightlight
        },
        className: `lni lni-close ${r.navbar__menuContainer__icon}`
      }
    ) : /* @__PURE__ */ t.createElement(t.Fragment, null, o.icon && /* @__PURE__ */ t.createElement("img", { className: r.menuImg, alt: "menu", src: o.icon }), !o.icon && /* @__PURE__ */ t.createElement(
      b,
      {
        style: {
          fill: e == null ? void 0 : e.hightLighHightlight
        },
        className: r.svg
      }
    ))
  )), o && a && /* @__PURE__ */ t.createElement(t.Fragment, null, n && /* @__PURE__ */ t.createElement("div", { className: r.navbar__profile }, /* @__PURE__ */ t.createElement(
    "div",
    {
      onClick: () => p(),
      className: r.navbar__profile__action
    },
    ((l = o.props.texts) == null ? void 0 : l.logout) || i("userMenu.logout")
  ), /* @__PURE__ */ t.createElement(
    "div",
    {
      className: r.navbar__rightContainer__profile,
      onClick: () => f()
    },
    /* @__PURE__ */ t.createElement(
      E,
      {
        backgroundColor: (e == null ? void 0 : e.content.userProfileBackground) || (e == null ? void 0 : e.accentColor),
        textColor: e == null ? void 0 : e.header.textColor,
        fullName: n.profile.name,
        size: 60
      }
    )
  )), !n && /* @__PURE__ */ t.createElement(
    "div",
    {
      onClick: () => h(),
      className: r.navbar__profile__action
    },
    ((c = o.props.texts) == null ? void 0 : c.login) || i("loginText")
  )));
}
export {
  z as RightSideMenu
};
//# sourceMappingURL=RightSideMenu.js.map
